<template>
<div>
    <div class="columns">
        <div class="column" >
            <div class="card" v-if="loaded">
                <div class="card-content">
                    <h4 class="title is-4 has-text-grey">
                            Créditos
                    </h4>
                    <p class="subtitle is-5 has-text-grey-dark">
                        {{numberFormat(credits.mount)}}
                    </p>
                </div>
                <footer class="card-footer">
                    <a @click="kind=4,modals.tranf=true" class="card-footer-item has-background-link-light">
                        <span class="icon"><fa icon="handshake" /></span> <span class="is-hidden-mobile">Transferir</span>
                    </a>
                    <a class="card-footer-item has-background-warning-light has-text-warning-dark" @click="buildBuyModal()">
                        <span class="icon"><fa icon="coins" /></span> <span class="is-hidden-mobile">Comprar</span>
                    </a>
                    <a @click="kind=2,modals.trans=true" class="card-footer-item has-text-info has-background-info-light">
                        <span class="icon"><fa icon="exchange-alt" /></span> <span class="is-hidden-mobile">Convertir</span>
                    </a>
                </footer>
            </div>
            <fa v-else icon="circle-notch" class="fa-4x has-text-white" spin />
        </div>
        <div class="column" >
            <div class="card" v-if="loaded">
                <div class="card-content">
                    <h4 class="title is-4 has-text-warning">
                            Zen
                    </h4>
                    <p class="subtitle is-5 has-text-grey-dark">
                        {{numberFormat(zen.mount)}}
                    </p>
                </div>
                <footer class="card-footer">
                    <a @click="kind=0,modals.inout=true" class="card-footer-item has-text-success has-background-success-light">
                        <span class="icon"><fa icon="level-up-alt" /></span> <span class="is-hidden-mobile">Depositar</span>
                    </a>
                    <a @click="kind=1,modals.inout=true" class="card-footer-item has-text-danger has-background-danger-light">
                        <span class="icon"><fa icon="level-down-alt" /></span> <span class="is-hidden-mobile">Retirar</span>
                    </a>
                    <a @click="kind=3,modals.trans=true" class="card-footer-item has-text-info has-background-info-light">
                        <span class="icon"><fa icon="exchange-alt" /></span> <span class="is-hidden-mobile">Convertir</span>
                    </a>
                </footer>
            </div> 
            <fa v-else icon="circle-notch" class="fa-4x has-text-white" spin />    
        </div>
    </div>

<article class="message is-info">
  <div class="message-body">
    <b>Información:</b> <br>Recuerda mantener tu cuenta desconectada del juego para que los cambios surtan efecto.
  </div>
</article>

    <transition name="fade">

    <in-out-bank-modal v-if="modals.inout"
        :show="modals.inout"
        :title="kind==0?'Depositar Zen':'Retirar Zen'"
        :characters="characters"
        :current="zen.mount"
        :type="kind"
        :loading="loading"
        @close-modal="modals.inout=false"
        @loading-run="loading=true"
        @loading-stop="loading=false"
        @form-submit="verifyProcess" />

    <trans-bank-modal v-if="modals.trans"
        :title="kind>2?'Convertir Zen a Créditos':'Convertir Créditos a Zen'"
        :show="modals.trans"
        :currentZen="zen.mount"
        :currentCredits="credits.mount"
        :type="kind"
        :loading="loading"
        @close-modal="modals.trans=false"
        @loading-run="loading=true"
        @loading-stop="loading=false"
        @form-submit="verifyTrans" />

    <tranf-bank-modal v-if="modals.tranf"
        :title="'Transferir Créditos a otro Jugador'"
        :show="modals.tranf"
        :currentCredits="credits.mount"
        :type="kind"
        :loading="loading"
        :characterSearch="charactersFilter"
        :characterOwn="characters"
        @close-modal="modals.tranf=false"
        @loading-run="loading=true"
        @loading-stop="loading=false"
        @setCharacters="setModalCharacters"
        @form-submit="verifyTranf" />

    <buy-modal v-if="modals.buy"
        :title="'Comprar Créditos'"
        :show="modals.buy"
        :loading="loading"
        :clientId="ppClientId"
        @close-modal="modals.buy=false"
        @loading-run="loading=true"
        @loading-stop="loading=false"
        @form-submit="processOrder" />

    </transition>


</div>


</template>

<script>
import UserService from '@/services/user.service.js';
// import ExtraService from '@/services/extra.service.js';
import InOutBankModal from '@/components/modals/webankInOut.vue'
import TransBankModal from '@/components/modals/webankTrans.vue'
import TranfBankModal from '@/components/modals/webankTranf.vue'
import BuyModal from '@/components/modals/webankBuy.vue'
import Swal from 'sweetalert2'
export default {
    name:'DashboardWebBank',
    props: {
        api:String,
        user:Object
    },
    components: {
        InOutBankModal, TransBankModal, 
        TranfBankModal, BuyModal
    },
    data:()=>({
        zen: {
            id:0,
            mount:0
        },
        credits: {
            id:0,
            mount:0
        },
        loading:false,
        characters: [],
        charactersFilter:[],
        kind:0,
        loaded:false,
        ppClientId:'',
        modals:{
            inout:false,
            trans:false,
            tranf:false,
            buy:false
        }
    }),
    computed: {
        numberFormat() {
            return this.$store.getters.numberWithCommas
        },
        costs() {
            return this.$store.getters.costs
        }
    },
    async created() {
        await this.$store.commit('changeDashboardPage', 3)
        if(this.user && this.user != undefined) {
            // const q1 = await UserService.getWebBank(this.user.pk)
            const q1 = this.$store.getters.GetJson('webank')
            var result1 = q1

            this.zen.mount = result1.zen.zen
            this.zen.id = result1.zen.id
            this.credits.id = result1.credits.id
            this.credits.mount = result1.credits.credits

            // const q2 = await UserService.getCharacters(this.user.username)
            const q2 = this.$store.getters.GetJson('dashboard-characters')
            var result2 = q2

            if(result2.game1) this.characters.push({value:result2.game1.name, display:`${result2.game1.name} - Zen ${this.numberFormat(result2.game1.money)}`, zen:result2.game1.money, name:result2.game1.name, id:result2.game1.id})
            if(result2.game2) this.characters.push({value:result2.game2.name, display:`${result2.game2.name} - Zen ${this.numberFormat(result2.game2.money)}`, zen:result2.game2.money, name:result2.game2.name, id:result2.game2.id})
            if(result2.game3) this.characters.push({value:result2.game3.name, display:`${result2.game3.name} - Zen ${this.numberFormat(result2.game3.money)}`, zen:result2.game3.money, name:result2.game3.name, id:result2.game3.id})
            if(result2.game4) this.characters.push({value:result2.game4.name, display:`${result2.game4.name} - Zen ${this.numberFormat(result2.game4.money)}`, zen:result2.game4.money, name:result2.game4.name, id:result2.game4.id})
            if(result2.game5) this.characters.push({value:result2.game5.name, display:`${result2.game5.name} - Zen ${this.numberFormat(result2.game5.money)}`, zen:result2.game5.money, name:result2.game5.name, id:result2.game5.id})

            this.loaded = true
        }

    },
    methods: {
        async setModalCharacters(char) {
            let characters = this.$store.getters.GetJson('players').results.filter(player => player.name.includes(char) )
            this.charactersFilter = []
                    for (var c in characters) {
                        var item = {
                            code: characters[c].name,
                            character: characters[c].name
                        }
                        this.charactersFilter.push(item)
                    }            
            // await UserService.getCharactersBasics(char)
            //     .then(response => {
            //         var result = response.data.results
            //         for (var r in result) {
            //             var item = {
            //                 code: result[r].name,
            //                 character: result[r].name
            //             }
            //             this.charactersFilter.push(item)
            //         }
            //     })
        },
        verifyTranf(form) {
            Swal.fire({
                    title: '¿Esta seguro que desea transferir '+this.numberFormat(form.mount)+' Créditos a '+form.selected.character+'?',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: "No, espera.",
                    confirmButtonText: "Si, transferir!"
                }).then((result) => {
                    if(result.value) {
                        this.TranfCredits(form)
                    } else { this.loading = false }
                })
        },
        verifyTrans(form) {
            Swal.fire({
                    title: '¿Esta seguro que desea convertir esa cantidad '+(this.kind>2?'Zen':'Créditos')+' a '+(this.kind>2?'Créditos':'Zen')+'?',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: "No, espera.",
                    confirmButtonText: "Si, convertir!"
                }).then((result) => {
                    if(result.value) {
                        this.transBank(form)
                    } else { this.loading = false }
                })
        },
        async processOrder(order) {
            this.modals.buy = false
            Swal.fire({
                title: 'Procesando su compra',
                text:'Por favor espere...',
                allowEscapeKey:false,
                allowOutsideClick:false,
                allowEnterKey:false,
                onBeforeOpen: async () => {
                    Swal.showLoading()
                    const formdata = new FormData()
                    formdata.append('order_id',order.cart)
                    await UserService.buyCredits(formdata)
                    .then(response => {
                        var data = response.data
                        Swal.fire({
                            icon: 'success',
                            title: 'Tu compra ha sido procesada satisfactoriamente!',
                            html: `<p>Se ha abonado a tu cuenta la cantidad de: <br> <b>${this.numberFormat(order.credits_mount)} Créditos</b>. <hr> Ahora tienes en tu posesión: <b>${this.numberFormat(data.credits)} Créditos</b></p>`,
                            showConfirmButton: true,
                            confirmButtonText: "¡Fantástico!",
                        }).then(()=>{
                            this.credits.mount = data.credits
                            Swal.close()
                        })
                    })
                    .catch(error => {
                        var backend_error_title = 'Ops, Ha ocurrido un error!'
                        var backend_error = ''
                        if ('info' in error.response.data) backend_error = error.response.data.info
                        Swal.fire({
                            icon: 'error',
                            title: backend_error_title,
                            text: backend_error,
                            confirmButtonText: "Ok.",
                        }).then(result => {
                            if (result){
                                Swal.close()
                            }
                        })
                })
                },
            })
        },
        async buildBuyModal() {
            // let {data} = await ExtraService.getPaypalData()
            let data = {"account":"sb-eeztp2865572@personal.example.com","client_id":"ASZFDHiwhfI_P7HA3KwyFyoG3w5oMBwX_X1UVTDXxl0vyR8LdTjz2X9nqeHrZhrjvDn0NxN6k_tuL0Io"}
            this.ppClientId = data.client_id
            this.modals.buy = true
        },
        async TranfCredits(data) {
            Swal.fire({
                position: 'top',
                icon: 'success',
                title: 'La transferencia ha sido realizada exitosamente!',
                showConfirmButton: false,
                timer: 3000,
                showClass: {
                    popup: 'animated fadeInDown faster'
                },
                hideClass: {
                    popup: 'animated fadeOutUp faster'
                }
            }).then(()=>{
                this.loading = false
                this.modals.tranf = false
            })            
            const formdata = new FormData()
            formdata.append('character',data.selected.code)
            // formdata.append('mount',data.mount)
            // formdata.append('alias',data.alias)
            
            // await UserService.makeCreditTransfer(formdata)
            //     .then(response => {
            //         data = response.data
            //         this.credits.mount = data.credits
            //         Swal.fire({
            //             position: 'top',
            //             icon: 'success',
            //             title: 'La transferencia ha sido realizada exitosamente!',
            //             showConfirmButton: false,
            //             timer: 3000,
            //             showClass: {
            //                 popup: 'animated fadeInDown faster'
            //             },
            //             hideClass: {
            //                 popup: 'animated fadeOutUp faster'
            //             }
            //         }).then(()=>{
            //             this.loading = false
            //             this.modals.tranf = false
            //         })
            //     })
            //     .catch(error => {
            //         var backend_error = 'Ha ocurrido un error!'
            //         if ('info' in error.response.data) backend_error = error.response.data.info
            //         Swal.fire({
            //             icon: 'error',
            //             title: backend_error,
            //             confirmButtonText: "Ok.",
            //         })
            //         this.loading = false
            //     })
        },
        async transBank(data) {
            var mount = parseInt(data.mount),
                credits = 0,
                zenBank = 0
            
            if(this.kind>2) {
                credits = this.credits.mount + mount
                zenBank =  this.zen.mount - (mount*this.costs.zenToCredits)
            } else {
                credits = this.credits.mount - (mount/this.costs.zenToCredits)
                zenBank =  this.zen.mount + mount
            }

            this.credits.mount = credits
            this.zen.mount = zenBank
            // await UserService.updateCredits(this.credits.id,{credits:credits})
            //     .then(response => {
            //         this.credits.mount = response.data.credits
            //     })
            // await UserService.updateZenBank(this.zen.id,{zen:zenBank})
            //     .then(response=> {
            //         this.zen.mount = response.data.zen
            //     })

            Swal.fire({
                position: 'top',
                icon: 'success',
                title: 'La conversión ha sido exitosa!',
                showConfirmButton: false,
                timer: 3000,
                showClass: {
                    popup: 'animated fadeInDown faster'
                },
                hideClass: {
                    popup: 'animated fadeOutUp faster'
                }
            }).then(()=>{
                this.loading = false
                this.modals.trans = false
            })

        },
        verifyProcess(form) {
            Swal.fire({
                    title: '¿Esta seguro de '+(this.kind>0?'retirar':'depositar')+' esta cantidad de Zen?',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: "No, espera",
                    confirmButtonText: "Si, "+(this.kind>0?'retirarlos':'depositarlos')+"!"
                }).then((result) => {
                    if(result.value) {
                        this.processZen(form)
                    } else { this.loading = false }
                })
        },
        async processZen(data) {
            this.$store.commit('setLoader', true)
            var totalBank = 0,
                totalCharacter = 0,
                preCharacterZen = 0,
                error = false,
                userMount = parseInt(data.mount)

            // await UserService.getServerCharacterZen(data.character.name)
            //     .then(response => {
            //         preCharacterZen = parseInt(response.data.money)
            //     })
            preCharacterZen = data.character.zen
            
            if (this.kind > 0) {
                totalCharacter = preCharacterZen + userMount
                totalBank = this.zen.mount - userMount             
            } else {
                totalCharacter = preCharacterZen - userMount
                totalBank = this.zen.mount + userMount
            }

            if (totalCharacter < 0) {
                var message = `Tu personaje no tiene esa cantidad de Zen, verifica nuevamente.`
                this.$toasted.show(message, { 
                    theme: 'toasted-danger', 
                    position: "top-center", 
                    duration : 5000
                });
                await this.refixCharacters({name:data.character.name, zen:preCharacterZen})
                this.loading = false
                this.$store.commit('setLoader', false)
                return
            }
            
            // await UserService.updateServerCharacterZen(data.character.name,{money:totalCharacter})
            //     .then(() => {
            //         UserService.updateCharacterZen(data.character.id, {money:totalCharacter})
            //     })
            //     .catch(serverError => {
            //         var result = serverError.response.data,
            //             message = ''
            //         if (result.status_code==403) message = 'Tu cuenta debe permanecer desconectada del juego para procesar esta transacción.'
            //         error = true
            //         Swal.fire({
            //             icon: 'error',
            //             title: 'Ops, Ha ocurrido un error!',
            //             text: message,
            //             showConfirmButton: true
            //         })
            //     })
            if(error) {this.loading = false; this.$store.commit('setLoader', false); return;}
            // await UserService.updateZenBank(this.zen.id,{zen:totalBank})
            //     .catch(()=>{
            //         error = true
            //         UserService.updateServerCharacterZen(data.character.name,{money:preCharacterZen})
            //         Swal.fire({
            //             position: 'top',
            //             icon: 'error',
            //             title: 'Ha ocurrido un error al procesar la transacción',
            //             showConfirmButton: true,
            //             showClass: {
            //                 popup: 'animated fadeInDown faster'
            //             },
            //             hideClass: {
            //                 popup: 'animated fadeOutUp faster'
            //             }
            //         })
            //     })
            if(error) {this.loading = false; this.$store.commit('setLoader', false); return;}

            this.zen.mount = totalBank
            await this.refixCharacters({name:data.character.name, zen:totalCharacter})
            this.$store.commit('setLoader', false)
            Swal.fire({
                position: 'top',
                icon: 'success',
                title: 'El '+(this.kind>0?'retiro':'deposito')+' se ha realizado correctamente!',
                showConfirmButton: false,
                timer: 3000,
                showClass: {
                    popup: 'animated fadeInDown faster'
                },
                hideClass: {
                    popup: 'animated fadeOutUp faster'
                }
            }).then(()=>{
                this.loading = false
                this.modals.inout = false
            })
            
            
        },
        refixCharacters(newChar) {
            for (var char in this.characters) if(this.characters[char].name === newChar.name) {
                this.characters[char].display = `${newChar.name} - Zen ${this.numberFormat(newChar.zen)}`
                this.characters[char].zen = newChar.zen
                break
            }
        }
    }

}
</script>
